import React, { FC, useEffect, useState } from 'react';
import { V12FianceProduct } from 'shared/types/payment/V12PaymentOption';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import { useAdyenCheckout } from 'components/commercetools-ui/organisms/checkout/provider';
import { V12PaymentData } from 'components/commercetools-ui/organisms/checkout/provider/payment/types';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart, useV12 } from 'frontastic';
import { calculate } from '../../helper/v12-calulation-helper';
import Message from 'components/commercetools-ui/atoms/message';

interface Props {
  setV12PaymentData: (data: V12PaymentData) => void;
  formatCheckoutMessage: any;
}

const V12: FC<Props> = ({ setV12PaymentData, formatCheckoutMessage }) => {
  const { getPaymentOptions } = useV12();
  const { setIsPaymentDataValid } = useAdyenCheckout();

  const { data } = useCart();
  const { formatMessage } = useFormat({ name: 'common' });

  const [aprtyp, setAprtyp] = useState('');
  const [monthly, setMonthly] = useState('');
  const [totalch, setTotalch] = useState('');
  const [totalpay, setTotalpay] = useState('');

  const [financeProducts, setFinanceProducts] = useState<V12FianceProduct[]>([]);
  const [selectedFinance, setSelectedFinance] = useState<V12FianceProduct>();

  useEffect(() => {
    const fetchPaymentOptions = async () => {
      try {
        let options = await getPaymentOptions();

        const cartTotal = data?.sum?.centAmount === undefined ? 0.0 : data?.sum?.centAmount / 100;
        options = options.filter((op) => {
          return op.MinLoan <= cartTotal && op.MaxLoan >= cartTotal;
        });

        setFinanceProducts(options);
        if (options?.length > 0) {
          //setSelectedFinance(options[0]);
        }
      } catch (error) {
        console.error('Failed to fetch finance options:', error);
      }
    };

    fetchPaymentOptions();
  }, [getPaymentOptions, data?.shippingAddress, data?.sum]);

  useEffect(() => {
    if (financeProducts.length > 0) {
      selectFianceOption(financeProducts[0]);
      setIsPaymentDataValid(true);
    }
  }, [financeProducts]);

  useEffect(() => {
    const total = data?.sum?.centAmount ? data?.sum?.centAmount / 100 : 0;
    refreshFinanceComponent(total, 'GBP');
  }, [selectedFinance]);

  const refreshFinanceComponent = (amountToPay: number, currencyCode: string) => {
    if (selectedFinance === undefined) {
      return;
    }
    const calcResults = calculate(selectedFinance, amountToPay, 0);
    const monthly = `${calcResults?.initialPayments} ${currencyCode}`;
    const totalch = `${calcResults?.chargeForCredit} ${currencyCode}`;
    const aprtyp = `${calcResults?.apr}%`;
    const totalpay = `${calcResults?.amountPayable} ${currencyCode}`;

    setMonthly(monthly);
    setTotalch(totalch);
    setAprtyp(aprtyp);
    setTotalpay(totalpay);
  };

  const handleChangeOption = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const selectedOption = financeProducts.find((item) => item.ProductId === Number(e.target.value));
    selectFianceOption(selectedOption);
  };

  const selectFianceOption = (selectedOption: V12FianceProduct | undefined) => {
    setSelectedFinance(selectedOption);
    if (selectedOption) {
      const paymentData = {
        deposit: 0,
        productGuid: selectedOption.ProductGuid.toString(),
        productId: selectedOption.ProductId.toString(),
        productName: selectedOption.Name,
      } as V12PaymentData;

      setV12PaymentData(paymentData);
    }
  };

  const dropdownList =
    financeProducts?.length > 0
      ? [
          { label: formatMessage({ id: 'please.select', defaultMessage: 'Please select' }), value: '' },
          ...financeProducts.map(({ Name, ProductId }) => ({ label: Name, value: ProductId.toString() })),
        ]
      : [];

  if (financeProducts?.length === 0) return <></>;
  return (
    <div className="p-24">
      {financeProducts?.length !== undefined && (
        <Dropdown
          name="selectAddress"
          items={dropdownList}
          defaultValue={selectedFinance?.ProductId.toString()}
          onChange={handleChangeOption}
          label={formatMessage({ id: 'select.address', defaultMessage: 'Select address' })}
        />
      )}
      <div id="v12-advise-customers" className="mt-24">
        <Message
          severity={'error'}
          message={formatCheckoutMessage({
            id: `payment.v12.addressMatchNotice`,
            defaultMessage:
              'Your delivery address will be taken directly from your V12 finance application form. So please ensure the address entered at checkout matches.',
          })}
          className="py-0"
        ></Message>
      </div>
      <div className="attribute-item-table mt-24">
        <table>
          <tbody>
            <tr className="attribute-item finance-amount">
              <td className="label pb-10 text-sm font-light">% APR Typical</td>
              <td className="value pb-10 text-sm font-medium">{aprtyp}</td>
            </tr>
            <tr className="attribute-item finance-amount">
              <td className="label pb-10 text-sm font-light">Monthly Payment</td>
              <td className="value pb-10 text-sm font-medium">{monthly}</td>
            </tr>
            <tr className="attribute-item finance-amount">
              <td className="label pb-10 text-sm font-light">Total Payable</td>
              <td className="value pb-10 text-sm font-medium">{totalpay}</td>
            </tr>
            <tr className="attribute-item finance-amount">
              <td className="label pb-10 text-sm font-light">Total Charges for Credit</td>
              <td className="value pb-10 text-sm font-medium">{totalch}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default V12;
